import { Box, TextField, Typography } from '@mui/material';

const CustomTextBox = ({ label, onChange, value, error, InputProps, rows }) => {
    return (
        <Box className="flex flex-col w-full mt-3">
            <Typography
                variant={'body14'}
                className={`${error ? 'text-red-500' : 'text-gray-500'} mb-1`}
            >
                {label}
            </Typography>
            <TextField
                // variant="outlined"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className="text-gray-500 h-12"
                error={error}
                InputProps={InputProps}
                rows={rows || 1}
                sx={{
                    '& .MuiOutlinedInput-root': {
                      '&.Mui-focused': {
                        borderColor: 'transparent', // Removes the focus border
                        outline: 'none', // Removes the outline
                      },
                    },
                    '& .MuiInputBase-root': {
                      '&.Mui-focused': {
                        borderColor: 'transparent', // Removes the focus border on InputBase-root
                        outline: 'none', // Removes the outline
                      },
                    },
                    '& .MuiInputBase-colorPrimary': {
                      '&.Mui-focused': {
                        borderColor: 'transparent', // Removes the focus border on InputBase-colorPrimary
                      },
                    },
                  }}
            />
        </Box>
    );
};

export default CustomTextBox;
